import React from 'react';
import { Container, Col } from 'react-bootstrap';
import TopNavBar from '../Components/TopNavBar';
import Kursas from '../Components/Kursas';
import Footer from '../Components/Footer';
import { Link } from 'react-router-dom';
import ContentBlock from '../Components/ContentBlock';
import KursaiService from '../Api/KursaiService';

class KursaiPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            pageName: 'Kursai',
            kursaiList: []
        }

    }

    componentDidMount() {
        KursaiService.getKursai().then((response) => {
            this.setState({ kursaiList: response.data });
        }).catch(error => {
            this.setState({
                kursaiList: []
            })
        });
    }

    render() {

        const pageStyle = {
            backgroundImage: "url(kursai-page-background.png)",
            height: '100vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        };


        return (
            <Container fluid style={pageStyle}>
                <TopNavBar activeRoute={2} />
                <Container>
                    <h1 className='page-title'>{this.state.pageName}</h1>
                    <ContentBlock>
                        {this.state.kursaiList.map((kursas, index) => {
                            var hrefString = '/kursai/' + kursas.ID;
                            return <Col key={index} xs={12} md={3} lg={3}>
                                <Link to={{ pathname: hrefString, state: { id: 100 } }} className="link-light">
                                    <Kursas Name={kursas.Name} Price={kursas.Price} Image={kursas.Files[0].Path} />
                                </Link>
                            </Col>
                        })
                        }
                    </ContentBlock>
                </Container>
                <Footer></Footer>
            </Container >
        );
    }
}

export default KursaiPage;